import { render } from "./Dashboard.vue?vue&type=template&id=2fbf4ede"
import script from "./Dashboard.vue?vue&type=script&lang=js"
export * from "./Dashboard.vue?vue&type=script&lang=js"

import "./Dashboard.vue?vue&type=style&index=0&id=2fbf4ede&lang=scss"
import "./Dashboard.vue?vue&type=style&index=1&id=2fbf4ede&lang=css"
script.render = render

export default script